import { Box } from '@zillow/constellation-10';

import { LoadingText } from '@zg-rentals/loading-components';

const LABEL_WIDTHS = ['96px', '80px', '112px', '72px', '104px', '88px'];

export default function NavigationSkeleton({ rows }: { rows: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, index) => (
        <Box
          key={index}
          asChild
          css={{
            display: 'flex',
            alignItems: 'center',
            gap: '400',
            width: '100%',
            paddingBlock: 'tight',
            paddingInline: 'tight',
          }}
        >
          <li data-testid="NavigationSkeleton" aria-hidden="true">
            <LoadingText isLoading loadingWidth="24px" css={{ marginTop: '[0]' }}>
              {null}
            </LoadingText>
            <LoadingText isLoading loadingWidth={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} css={{ marginTop: '[0]' }}>
              {null}
            </LoadingText>
          </li>
        </Box>
      ))}
    </>
  );
}
